import React from 'react';

const ProblemStatementSection = () => {
  return (
    <section className="py-16 px-4 bg-[#040c14] relative">
      <div className="max-w-4xl mx-auto text-center">
        <p className="text-2xl md:text-3xl lg:text-4xl text-white font-light leading-relaxed">
          Most books never get <span className="text-[#FF6500] font-medium">seen</span>.
        </p>
        <p className="text-lg md:text-xl text-[#666] mt-4 max-w-2xl mx-auto">
          Not because the story isn't good, but because there's nothing to show. We change that.
        </p>
        
        {/* Product names visibility */}
        <div className="mt-12 pt-8 border-t border-[#152840]">
          <p className="text-xs text-[#555] uppercase tracking-widest mb-6">Our Visual Development Services</p>
          <div className="flex flex-wrap justify-center gap-4 md:gap-8">
            <span className="text-sm md:text-base text-[#888] hover:text-[#FF6500] transition-colors cursor-default">Design Bibles</span>
            <span className="text-[#333]">•</span>
            <span className="text-sm md:text-base text-[#888] hover:text-[#FF6500] transition-colors cursor-default">Book Trailers</span>
            <span className="text-[#333]">•</span>
            <span className="text-sm md:text-base text-[#888] hover:text-[#FF6500] transition-colors cursor-default">Concept Trailers</span>
            <span className="text-[#333]">•</span>
            <span className="text-sm md:text-base text-[#888] hover:text-[#FF6500] transition-colors cursor-default">Scene Reels</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProblemStatementSection;
